    // *********************************************************METEO*****************************************************
    // ************************APIKEY************************************
    const APIKEY = '08d883cc7241c3695d3ece775440dc7d'
    
    // let url `https://api.openweathermap.org/data/2.5/weather?lat={lat}&lon={lon}&appid={API key}`;
// let url = `https://api.openweathermap.org/data/2.5/weather?q=Rouen&appid=${APIKEY}&units=metric&lang=fr`;

// *******************************URL API**************************************
// let url = `https://api.openweathermap.org/data/2.5/weather?q=Nogent-sur-seine&appid=${APIKEY}&units=metric&lang=fr`;

// fetch(url).then(Response => Response.json().then(data =>console.log(data)));
// fetch(url).then(Response =>Response.json().then(data =>{console.log(data)}));

// fetch(url).then((Response) =>
//     Response.json().then((data) =>{
    //         console.log(data);
    //     })
    // );
    
    // ***********************************APICALL*******Appel à l'API openWeather avec la ville en parametre de fonction*********
    let apiCall = function(city){
        // ******************************************URL API***********************************************
        let url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${APIKEY}&units=metric&lang=fr`;
        // ********************************************FETCH***********************************************
        fetch(url).then((Response) =>
        Response.json().then((data) =>{
            console.log(data);
            document.querySelector('#city').innerHTML = "<i class='fa-solid fa-location-dot'></i>" + data.name;
            document.querySelector('#temp').innerHTML = "Température " + "<i class='fa-solid fa-temperature-three-quarters'></i>" + data.main.temp +'°C';
            document.querySelector('#humidity').innerHTML = "Humidité " + "<i class='fa-solid fa-droplet'></i>" + data.main.humidity + '%';
            document.querySelector('#wind').innerHTML = "Vent " + "<i class='fa-solid fa-wind'></i>" + data.wind.speed + 'm/s';
            document.querySelector('#pressure').innerHTML = "Pression " + "<i class='fa-solid fa-gauge-simple-high'></i>" + data.main.pressure +'hPa';
            document.querySelector('#visibility').innerHTML = "Visibilité " + "<i class='fa-solid fa-binoculars'></i>" + data.visibility +'m';
            document.querySelector('#feels_like').innerHTML = "T°Ressentie " + "<i class='fa-solid fa-temperature-three-quarters'></i>" + data.main.feels_like +'°C';
            document.querySelector('#description').innerHTML = "Description" + "<i class='fa-solid fa-eye'></i>"+ data.weather[0].description;
        })
        ).catch(err => console.log('Erreur : ' + err));
    }

    // *************************LISTENING TO FORM MODIFS*****Ecouteur d'evenement sur la soumission du formulaire*********************************************
    document.querySelector('form').addEventListener('submit', function(e){
        e.preventDefault();
        let ville = document.querySelector('#inputCity').value;
        apiCall(ville)
    })
    // ******CITY DEFAULT CALL ********************appel par defaut de la ville au chargement de la page**********************************
    apiCall('Nogent-sur-Seine')
    